import { types, actions } from './requests'
export const GETWORKORDERLISTSPAN_TYPES = {
    ...types('GETWORKORDERLISTSPAN'),
}
export const GETWORKORDERLISTSPAN_ACTIONS = {
    ...actions('GETWORKORDERLISTSPAN'),
}